import { render, staticRenderFns } from "./FactoryTypeCreate.vue?vue&type=template&id=539dc6ed&scoped=true"
import script from "./FactoryTypeCreate.vue?vue&type=script&lang=js"
export * from "./FactoryTypeCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539dc6ed",
  null
  
)

export default component.exports